module.exports = __webpack_public_path__ + "img/logo.e0039da3.png";